import React, { useState, useContext, useEffect } from "react";
import Navbar from '../Components/NavBarDashboard';
import Footer from '../Components/Footer';
import DashboardContent from '../Components/DashboardContent'; 
import AddAddress from '../Components/AddAddress'; 
import AllAddresses from '../Components/AllAddresses';
import CurrentOrders from '../Components/CurrentOrders';
import HistoryOrder from '../Components/HistoryOrder';
import SavedItems from '../Components/SavedItems';
import Profile from '../Components/Profile';
import { AuthContext } from '../Components/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import menu from '../Images/menu.png';
import FixedImageMessage from '../Components/FixedImageMessage';


const Dashboard = () => {
  // State to keep track of active link
  const [activeLink, setActiveLink] = useState('Dashboard');
  const { token, setToken, userData, setUserData  } = useContext(AuthContext); 
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.activeLink) {
      setActiveLink(location.state.activeLink);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          "https://backend.printtrio.co.uk/api/profile/get-user-data",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          const userData = response.data.data;
          setUserData({
            firstName: userData.first_name || "",
            lastName: userData.last_name || "",
            image: userData.image || "",
            
          });
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };

    if (token) {
      fetchUserData();
    }
  }, [token, setUserData]);

  const handleLinkClick = async (linkName) => {
    if (linkName === 'Logout') {
      try {
        const response = await fetch('https://backend.printtrio.co.uk/api/profile/logout', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();

        if (data.success) {
          console.log('Logout successful:', data.data.message);

          // Clear user data and token
          setUserData({});
          setToken('');
          localStorage.removeItem('token');
          localStorage.removeItem('firstName');
          localStorage.removeItem('lastName');
          localStorage.removeItem('image');
          document.cookie = "isLoggedIn=false; path=/";

          navigate('/'); // Redirect to home page
        } else {
          console.error('Logout failed:', data.message);
        }
      } catch (error) {
        console.error('Error during logout:', error);
      }
    } else {
      setActiveLink(linkName); // Update active link for other navigation items
    }
  };

  return (
    <>
      <Navbar />
      
      <div className="flex  py-0 px-2 md:px-16 xl:px-48 relative max-w-screen-2xl mx-auto px-4 xl:px-20 relative">
     
      <button
          className="lg:hidden absolute top-4 left-4 z-50"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <img src={menu} alt="Menu" className="h-8 w-8" />
        </button>

        {/* Sidebar */}
        <div
   className={`fixed top-0 bottom-0 left-0 h-[50%] bg-[#EBF2F8] shadow-lg p-6 flex flex-col justify-between w-64 transform transition-transform duration-300 lg:relative lg:translate-x-0 z-10 ${
     isSidebarOpen ? "translate-x-0" : "-translate-x-full"
   }`}
 >
          <div className="pt-[5%] pb-[10%]">
            <div className="flex flex-col items-center mb-10 mt-20 lg:mt-0">
              {/* Profile Image */}
              <img
                src={userData.image}  // Use userData.image
                alt="Profile"
                className="h-20 w-20 rounded-full mb-4"
              />
              {/* User Name */}
              <h2 className="text-gray-800 font-semibold">
               {userData.firstName} {userData.lastName}
             </h2>            </div>

            {/* Navigation Links */}
            <nav className="flex flex-col space-y-4 text-gray-600 text-sm">
              {['Dashboard', 'Current Orders', 'History', 'Saved Items', 'Add Address', 'All Address', 'Profile'].map((link) => (
                <a
                  key={link}
                  href="#"
                  onClick={() => handleLinkClick(link)}
                  className={`py-2 transition
                    ${activeLink === link ? 'bg-[#71BAF9] text-white px-4 rounded-md' : 'text-[#191919] hover:text-[#71BAF9]'}`}
                >
                  {link}
                </a>
              ))}
            </nav>
          </div>

          {/* Logout Link at the Bottom */}
          <div className="mt-20 mb-5">
            <a
              href="#"
              onClick={() => handleLinkClick('Logout')}
              className="py-2 text-[#191919] hover:text-[#71BAF9] transition"
            >
              Logout
            </a>
          </div>
        </div>
        <div className="flex flex-col w-full">
        <h1 className="text-xl font-bold text-gray-800 mt-5 ml-16 md:ml-20">{activeLink}</h1>

        {/* Main Content */}
        {activeLink === 'Dashboard' && <DashboardContent setActiveLink={setActiveLink} />}
        {activeLink === 'Add Address' && <AddAddress token={token} />}
        {activeLink === 'All Address' && <AllAddresses token={token} />}
        {activeLink === 'Current Orders' && <CurrentOrders token={token} />}
        {activeLink === 'History' && <HistoryOrder token={token} />}
        {activeLink === 'Saved Items' && <SavedItems token={token} />}
        {activeLink === 'Profile' && <Profile token={token} />}
        </div>
      </div>
      <FixedImageMessage />

      <Footer />
    </>
  );
};

export default Dashboard;
